import { z } from "zod";
import { isPhoneComplete } from "@/shared/utils";

export const createVolunteerSchema = z.object({
  surname: z.string().min(1, "validation.field.error.required"),
  name: z.string().min(1, "validation.field.error.required"),
  father_name: z.string().optional().or(z.literal("")),
  email: z.string().min(1, "validation.field.error.required").email("validation.field.error.invalidEmail"),
  phone: z
    .string()
    .min(1, "validation.field.error.required")
    .refine(isPhoneComplete, "validation.field.error.invalidPhone"),
  region_id: z.number({ error: "validation.field.error.required" }),
  date_of_birth: z.string().min(1, "validation.field.error.required"),
});

export type CreateVolunteerFormValues = z.infer<typeof createVolunteerSchema>;
